import React from 'react';
import styles from './Settings.module.css';

const Settings: React.FC = () => {
    return (
        <div className={styles.container}>
            <h2>Settings Page</h2>
            <p>Application settings content will go here.</p>
        </div>
    );
};

export default Settings; 